import * as Sentry from '@sentry/react'
import * as React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import * as serviceWorker from './serviceWorker'
import 'ply-utils/mui'
import '@fontsource-variable/inter'
import '@fontsource/space-grotesk/600.css'
import { initSentry } from 'ply-shared/sentry'
import {
	createRoutesFromChildren,
	matchRoutes,
	useLocation,
	useNavigationType,
} from 'react-router'

initSentry({
	dsn: 'https://262b9705883942d8a3ed24af910e657f@o4509797266423808.ingest.us.sentry.io/4509858611920896',
	project: 'front-excitead',
	applicationKey: 'front-excitead',
	getIntegrations: (base) => [
		...base,
		Sentry.reactRouterV6BrowserTracingIntegration({
			useEffect: React.useEffect,
			useLocation,
			useNavigationType,
			createRoutesFromChildren,
			matchRoutes,
		}),
		Sentry.replayIntegration({
			maskAllText: false,
			blockAllMedia: false,
		}),
	],
})

const el = document.getElementById('root') as any
const root = createRoot(el)
root.render(<App />)

serviceWorker.register()
